// @flow

import * as atypes from "src/constants/actionTypes";

export const getMyConversatoinChart = ({
  tileId,
  filter
}: {
  tileId: string,
  filter: Object
}) => ({
  type: atypes.GET_MY_CONVERSATION_CHART_REQUEST,
  payload: { tileId, filter }
});

export const setHomescreen = () => ({
  type: atypes.SET_HOME_SCREEN_REQUEST,
  payload: {}
});

export const openHomeScreenTile = (analytics: Object) => ({
  type: atypes.OPEN_HOME_SCREEN_TILE,
  payload: { analytics }
});
